export const HOME_TAB_FEED_SCREEN = "index" as const;
export const HOME_TAB_GROUPS_SCREEN = "groups" as const;

export const HOME_ROUTE_FEED = "/(tabs)" as const;
export const HOME_ROUTE_GROUPS = "/(tabs)/groups" as const;

export type DefaultHomeTab = "feed" | "groups";

export const resolveHomeTabScreen = (pref: DefaultHomeTab | null | undefined) =>
  pref === "groups" ? HOME_TAB_GROUPS_SCREEN : HOME_TAB_FEED_SCREEN;

export const resolveHomeRoute = (pref: DefaultHomeTab | null | undefined) =>
  pref === "groups" ? HOME_ROUTE_GROUPS : HOME_ROUTE_FEED;

// Back-compat aliases for callsites that intentionally always navigate to
// groups (groups-tab tabPress listeners, settings header back button). Keep
// these pointing at groups so those sites don't need to change.
export const APP_HOME_TAB_SCREEN = HOME_TAB_GROUPS_SCREEN;
export const APP_HOME_ROUTE = HOME_ROUTE_GROUPS;
